import {useState} from 'react';
import type {Article} from '../types/article';

interface ArticleImageProps {
  readonly className?: string;
  readonly fetchPriority?: 'high' | 'low' | 'auto';
  readonly image: NonNullable<Article['image']>;
}

export const ArticleImage = ({className, fetchPriority, image}: ArticleImageProps) => {
  const [failed, setFailed] = useState(false);

  if(failed) {
    return <span aria-label={`Image unavailable: ${image.alt}`} className={`${className ?? ''} article-image--unavailable`.trim()} role="img">Image unavailable</span>;
  }

  return (
    <img
      alt={image.alt}
      className={className}
      decoding="async"
      fetchPriority={fetchPriority}
      loading={fetchPriority === 'high' ? 'eager' : 'lazy'}
      onError={() => setFailed(true)}
      src={image.url}
    />
  );
};
